import {styled} from '@mui/system';
import theme from '../theme';

const ButtonStyle = styled('div')({
  button: {
    backgroundColor: theme.colors.black,
    color: theme.colors.white,
  },
  'button:hover': {
    background: theme.colors.black,
  },
});

export default ButtonStyle;
